import React, { useState } from 'react'
// import { FaPlus } from 'react-icons/fa'
import emailjs from '@emailjs/browser'
import { useTranslation } from 'react-i18next'

const serviceId = 'service_whoihxr'
const templateId = 'template_8gg66m6'
const publicKey = 'xSSzcMTE6i1IZbzSg'

const ContactAreaFour = () => {
  const { t } = useTranslation()
  const [name, setName] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')

  const handleClick = (e) => {
    e.preventDefault()

    const templateParams = {
      name,
      companyName,
      email,
      message,
    }
    if (name == '' || companyName == '' || email == '' || message == '') {
      alert('All field are required')
    } else
      emailjs
        .send(serviceId, templateId, templateParams, publicKey)
        .then((res) => {
          console.log('email sent successfully', res)
          setName('')
          setCompanyName('')
          setEmail('')
          setMessage('')
        })
        .catch((err) => {
          console.log(err)
        })
  }

  return (
    <>
      {/*================= counter area start {/*=================*/}
      <div
        id="#contactus"
        className="contact-area pd-top-90 pd-bottom-120 bg-gray"
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 order-lg-end "
              data-aos="fade-left"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div className="about-thumb-inner ms-xl-5 p-xl-5 pt-4 ">
                <img
                  className="animate-main-img"
                  src="assets/img/about/18.png"
                  alt="img"
                />
                <img
                  className="main-img m-4"
                  src="assets/images/contactus.png"
                  alt="img"
                />
              </div>
            </div>
            <div
              className="col-lg-6 order-lg-first "
              data-aos="fade-right"
              data-aos-delay="200"
              data-aos-duration="1500"
            >
              <div className="section-title mb-0 mt-5 mt-lg-0">
                <h6 className="sub-title">GET IN TOUCH</h6>
                {/* <h2 className="title">
                  Your Business To <span>Growth</span> Please Touch ?
                </h2> */}
                <div
                  dangerouslySetInnerHTML={{ __html: t('contact-us-title') }}
                ></div>
                {/* <p className="content">{t('contact-us-subtitle')}</p> */}
                <form className="mt-4">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="single-input-inner style-border">
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder={t('name')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="single-input-inner style-border">
                        <input
                          type="text"
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                          placeholder={t('companyName')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="single-input-inner style-border">
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder={t('email')}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="single-input-inner style-border">
                        <textarea
                          placeholder={t('message')}
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          defaultValue={''}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-border-gray mt-0"
                        onClick={handleClick}
                      >
                        {t('contactus')}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*{/*================= counter area end {/*=================*/}
    </>
  )
}

export default ContactAreaFour
